import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import createSiteIcon from "svg/createSite.svg";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import SelectProject from "components/siteRepo/createSite/selectProject";
import SiteDetails from "components/siteRepo/createSite/siteDetails";
import "./style.scss";

const CreateSite = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="container-fluid search-form-container create-site d-flex flex-column">
      <div className="search-form-container__title d-flex align-items-center">
        <img src={createSiteIcon} alt="Create site icon" className="create-site__icon" />
        <span className="search-form-container__title--text">Create a new site</span>
      </div>
      <Tabs transition={false} activeKey={location.hash} onSelect={(key) => navigate(`/siteRepo/createSite${key}`)}>
        <Tab eventKey="#select-project" title="Select a Project">
          <SelectProject />
        </Tab>
        <Tab eventKey="#site-details" title="Site Details">
          <SiteDetails />
        </Tab>
      </Tabs>
    </div>
  );
};

export default CreateSite;
